import { memo } from "react";
import { Link } from "react-router-dom";
import { Card, CardSizesEnum } from "@monorepo/components";

interface ICartLinkProps {
  to: string;
  isActive: boolean;
  children: React.ReactNode;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const CartLink: React.FC<ICartLinkProps> = memo(({ to, isActive, children, onMouseEnter, onMouseLeave }) => {
  return (
    <Link
      style={{
        textDecoration: "none",
        color: "inherit",
      }}
      to={to}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <Card size={CardSizesEnum.SMALL} active={isActive}>
        {children}
      </Card>
    </Link>
  );
});
